export class GenerarEncuesta {

  evaluadorid: any[] = [];
  fechaenvio: any = "";
  horaenvio: any = "";
  nivelid: any[] = [];
  cicloid: number = 0;

  constructor(init?: Partial<GenerarEncuesta>) {
      Object.assign(this, init);
  }
}
